module.exports = __webpack_public_path__ + "04ab76e7405d327f314386599ec9cb17.png";